import { images } from './index';

const projectTitles = [
  'Green Park Residence A-12',
  'C-22 Shyam Vihar',
  'Block-A Green Park',
  'Sector 105 Noida',
  'Sector 100 Noida',
  'Doctor Sharma Residence, Delhi',
  'Sector 100 Residence, Noida',
  'East Delhi Residence',
  'Official Residence, Najafgarh',
];

const projectCategories = [
  'architecture',
  'architecture',
  'architecture',
  'architecture',
  'architecture',
  'architecture',
  'architecture',
  'architecture',
  'architecture',
];

const projectLocations = [
  'Green Park, Delhi',
  'Shyam Vihar, Delhi',
  'Green Park, Delhi',
  'Sector 105, Noida',
  'Sector 100, Noida',
  'Delhi',
  'Sector 100, Noida',
  'East Delhi',
  'Najafgarh, Delhi',
];

export const projects = images.projects.map((image, index) => {
  const id = index + 1;
  const gallery = images.projectGalleries[id] || [];

  return {
    id,
    image,
    gallery: gallery.length > 0 ? gallery : [image],
    number: String(id).padStart(2, '0'),
    category: projectCategories[index] || 'architecture',
    title: projectTitles[index] || `Project ${String(id).padStart(2, '0')}`,
    location: projectLocations[index] || 'Noida',
    link: `/project/${id}`,
  };
});

export default projects;
